import React from "react";
import { MdFlashOn, MdFlashOff, MdCameraswitch } from "react-icons/md";

/**
 * Bottom control bar: Flash | Auto-toggle | Capture | Page count | Switch camera
 */
const ScannerControls = ({
  onCapture,
  onFlashToggle,
  onCameraSwitch,
  isFlashOn,
  autoCapture,
  onAutoCaptureToggle,
  pageCount,
  isCameraReady,
  isProcessing,
  stability,
  hasTorch,
  cameraCount,
}) => {
  // Stability ring SVG
  const ringRadius = 40;
  const circumference = 2 * Math.PI * ringRadius;
  const dashOffset = circumference * (1 - (stability || 0));

  return (
    <div className="ds-controls">
      {/* Flash toggle */}
      <button
        className={`ds-ctrl-btn ${isFlashOn ? "ds-flash-on" : ""}`}
        onClick={onFlashToggle}
        disabled={!isCameraReady}
        aria-label={isFlashOn ? "Turn off flash" : "Turn on flash"}
      >
        {isFlashOn ? <MdFlashOn /> : <MdFlashOff />}
      </button>

      {/* Auto-capture toggle */}
      <div className="ds-auto-toggle" onClick={onAutoCaptureToggle}>
        <div className={`ds-auto-switch ${autoCapture ? "ds-auto-on" : ""}`} />
        <span>Auto</span>
      </div>

      {/* Capture button with stability ring */}
      <button
        className="ds-capture-btn"
        onClick={onCapture}
        disabled={!isCameraReady || isProcessing}
        aria-label="Capture"
      >
        <div className="ds-capture-inner" />

        {/* Stability ring */}
        {stability > 0 && (
          <svg className="ds-stability-ring" viewBox="0 0 92 92">
            <circle
              className="ds-stability-circle"
              cx="46"
              cy="46"
              r={ringRadius}
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
            />
          </svg>
        )}

        {/* Page count badge */}
        {pageCount > 0 && (
          <span className="ds-page-badge">{pageCount}</span>
        )}
      </button>

      {/* Camera switch */}
      <button
        className="ds-ctrl-btn"
        onClick={onCameraSwitch}
        disabled={!isCameraReady || cameraCount <= 1}
        aria-label="Switch camera"
      >
        <MdCameraswitch />
      </button>
    </div>
  );
};

export default ScannerControls;
